import { render, staticRenderFns } from "./CustomerTrainingProgressBar.vue?vue&type=template&id=c96c2984&"
import script from "./CustomerTrainingProgressBar.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports